import Checkbox from '@amzn/meridian/checkbox';
import { localizeWithRef } from './localize';

export default localizeWithRef(Checkbox, ['children']);
